import { authHandlers } from "./auth";
import { enrollmentHandlers } from "./enrollment";
import { peopleHandlers } from "./people";
import { inviteCodeHandlers } from "./inviteCodes";
import { productHandlers } from "./products";
import { takHandlers } from "./tak";
import { mtxHandlers } from "./mtx";
import { matrixHandlers } from "./matrix";
import { proxyHandlers } from "./proxy";

/**
 * Order matters: MSW returns the first handler whose path matches.
 *
 * Pattern:
 *   1. Domain-specific groups (uiv2's own API surface).
 *   2. Integration-specific groups (one per supported integration).
 *   3. Proxy catch-all LAST so it only handles paths nothing else owns.
 */
export const handlers = [
  ...authHandlers,
  ...enrollmentHandlers,
  ...peopleHandlers,
  ...inviteCodeHandlers,
  ...productHandlers,
  ...takHandlers,
  ...mtxHandlers,
  ...matrixHandlers,
  ...proxyHandlers,
];
